<template>

  <span class="country-input"  @click="showPrefixMenu">

    <div class="mdl-textfield mdl-textfield--floating-label is-upgraded" ref="country"
         :class="{
           'is-invalid': invalid || (required && empty) ,
           'is-dirty' : !empty
         }">
      <span class="value mdl-textfield__input">
        <span v-if="!empty" class="countryFlag flag-icon" :class="'flag-icon-'+(liveValue.toLowerCase())"></span>
        {{ name }} &nbsp;
      </span>
      <span class="mdl-textfield__label">{{ label }}</span>

      <span class="more">
        <span>▾</span>
      </span>
    </div>

  </span>

</template>

<script>
  import api from "api"
  import countries from "../../config/countries"
  import overlayModel from "./overlayModel.js"
  import CountryPicker from "./CountryPicker.vue"

  require("flag-icon-css/css/flag-icon.css")

  export default {
    name: 'country-input',
    props: {
      value: {
      },
      required: {
        type: Boolean,
        required: true
      },
      label: {
        type: String
      },
      invalid: {
        type: Boolean
      }
    },
    data () {
      return {
        liveValue: this.value
      }
    },
    computed: {
      empty() {
        if(!this.liveValue) return true
        if(this.liveValue.trim().length == 0) return true
        return false
      },
      name() {
        if(this.empty) return ""
        let country = countries.filter(c => c.code == this.liveValue)[0]
        if(!country) return "Unknown"
        return country.name
      }
    },
    watch: {
      geoIpIsoCode(iso) {
        if(!this.isoCode) {
          this.isoCode = iso
          this.prefix = countries.filter(country=> country.code == iso)[0].dial_code
        }
      },
      liveValue(value) {
        this.$emit('update:value', value)
      },
      invalid(v) {
        if(!v) return
        if(!this.number.match(/^[0-9 #+-]{3,}$/)) {
          this.$refs.number.parentElement.setAttribute('class',
            this.$refs.number.parentElement.getAttribute('class')+' is-invalid')
        }
      }
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    created() {
    },
    mounted() {
      componentHandler.upgradeAllRegistered()
    },
    methods: {
      showPrefixMenu() {
        overlayModel.show({
          component: CountryPicker,
          props: {
            anchor: overlayModel.elementAnchor(this.$refs.country)
          },
          on: {
            selected: (code) => {
              console.log("SELECTED COUNTRY", code)
              this.liveValue = code
            }
          }
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .country-input {
    display: inline-block;
    position: relative;
  }

/*

  .country {
    border-bottom: 1px solid rgba(0,0,0,.12);
    position: relative;
    top: 0px;
    padding: 0;
    padding-top: 4px;
    padding-bottom: 4px;
    cursor: default;
    vertical-align: baseline;
  }
  .country.is-invalid {
    border-bottom: 1px solid #d50000;
  }
  .country

  .mdl-textfield {
    overflow: visible;
  }

  .is-invalid .mdl-textfield__label {
    color: #d50000;
    font-size: 0.8em;
    padding-top: 0.2em;
    bottom: 0;
    overflow: visible;
  }
*/
  .more {
    position: absolute;
    right: 0;
    top: 24px;
  }
  .countryFlag {
    width: 1.333em;
    height: 1em;
    top: -2px;
  }
</style>



// WEBPACK FOOTER //
// CountryInput.vue?6910df9c